import React from 'react';
import { Form, Select } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';

const IspEmails = (props) => {
  const { getFieldDecorator } = props.form;

  const validateValue = (_, values, callback) => {
    /* eslint-disable */
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    /* eslint-enable */
    const invalidInputs = values.filter(value => !value.match(emailRegex));
    if (invalidInputs.length === 0) {
      callback();
    } else {
      callback(props.intl.formatMessage({
        id: 'Component.Administration.Clients.Features.MarkAsIsp.Validation.Emails',
      }, {
        data: invalidInputs.join(', '),
      }));
    }
  };

  return (
    <Form.Item label={<FormattedMessage id="Component.Administration.Clients.Features.MarkAsIsp.Emails" />}>
      {getFieldDecorator('settings.feature_mark_as_isp_emails', {
        rules: [{
          required: true,
          validator: validateValue,
        }],
        initialValue: props.initialValue,
      })(
        <Select mode="tags" />,
      )}
    </Form.Item>
  );
};

export default connect()((injectIntl(IspEmails)));



// WEBPACK FOOTER //
// ./src/components/Clients/IspEmails/IspEmails.js